import { useContext, useEffect, useState } from "react"
import api, { ApiErrorHandler } from "../../util/api"
import { Player } from "@lottiefiles/react-lottie-player"
import loading_casino from "../../_asset/lottie/ready_casino.json"
import { UserContext } from "../_root"

export default function HoldemPopWindow(){
    const {User, UserAuth} = useContext(UserContext)
    const [link, setLink] = useState<string>()

    useEffect(()=> {
        api(`/api/game/games/link/realpoker`)
            .then(res=> res.json())
            .then((data: {link: string}) => {
                if(data?.link){
                    setLink(data.link)  
                }
            })
            .catch((res: Response)=> {
                ApiErrorHandler(res, ()=> {
                    window.close()
                })
            })
    }, [])
    return (
        <div className="game-window-layout">
            {
            User && !UserAuth
                ? <>
                    <p>로그아웃 되었습니다.</p>
                </>
                : link
                    ? <iframe className={'iframe-game-window a'}
                            onLoad={resizeViewportSet}
                            // onContextMenu={handleContextMenu}
                            src={link}
                            frameBorder="0"></iframe>
                    : <>
                        <Player src={loading_casino} loop autoplay ></Player>
                        <p>불러오는 중 입니다...</p>
                    </>
            }
        </div>
    )
}

function resizeViewportSet(){
    let vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
}